/**
 * @flow
 */
import React from 'react';
import ReactDom from 'react-dom';
import App from './components/App/app';
import Dialogs, { DIALOG } from './components/Dialogs/dialogs';
import type {
    TaskInfoType,
    TransitionInfoType
} from './lib/stories-shared';
import {
    atoi, getEl, getEls, addClass, getStyle,
    removeClass, getHTMLData
} from './lib/stories-shared';
import Armap from './lib/armap';
import './index.scss';
import './keyframes.css';
import Social from './components/Social/social';
import _ from './constants';
import {throttle, isMobileBrowser } from './lib/utils';
import im from "include-media-export/include-media";
import $ from 'jquery';


declare var storyTitle: string;
declare var transitionsData: Array<TransitionInfoType>;
declare var contentPool: string;
declare var contentId: string;

export const isMobile = !im.greaterThan('mobile');

if (isMobileBrowser) {
    require("react-tap-event-plugin")();
}

const showDialog = function (p: number, data?:any) {
    pDialogs.setState({dialog: p, data: data});
};

const pDialogs = ReactDom.render(
    <Dialogs projectName={ storyTitle }
        contentPool={contentPool}
        contentId={contentId}
    />,
    document.getElementById('dialogs')
);

const tasks = getEls('section.clsStory-section').map(e => {
    const {taskId: id, col: colId, row: rowId, title: name} = getHTMLData(e);
    return {
        id, colId, rowId, name
    }
});

const pApp = ReactDom.render(
    <App
        tasks={Armap.fromArray('id', tasks)}
        transitions={Armap.fromArray('id', transitionsData)}
        dialogInterface={showDialog}
    />,
    document.getElementById('clsStory-tree')
);

ReactDom.render(
    <Social
        projectName={ storyTitle }
    />,
    document.getElementById('clsSocial')
)

const hEl = getEl('header.clsPageHeader');
const bgEl = getEl('div.clsStory-cover');
const tocEl = getEl('div.clsTOCHandler');
const socEl = getEl('.clsSocialContainer');
const $ani = $([hEl, tocEl, socEl]);
const hCss = getComputedStyle(hEl);
const bgCss = getComputedStyle(bgEl);
const win = window;
let hMode: boolean = false;
let staPopup = null;
let $tutorialPopup = isMobile && $(`
    <div class="clsTutorial">
        <div class="clsArrows">
            <svg><use xlink:href="#clsArrows" /></svg>
            <svg><use xlink:href="#clsArrows" /></svg>
        </div>
        <div>Check a visual workflow<br /> of this guide</div>
    </div>
`).on('click', () => {
    $('.clsTutorial').fadeOut(() => {
        $('.clsTutorial').remove();
        $tutorialPopup = null;
    });
}) || null;

let tutCounter = parseInt(localStorage.getItem(_.gcTutorialPopupKey) || 0, 10);
let tutorialShown = tutCounter > 2;

const scrollHandler = (initial: boolean = false) => {
    const top: number = atoi(hCss.top);
    const height: number = atoi(hCss.height);
    const bgHeight: number = atoi(bgCss.height);

    if (win.scrollY > top + height) {
        if (!hMode) {
            addClass(hEl, 'clsScrolled');
            $ani.css('animationDelay', '0s')
            hMode = true;
        } else {
            const p:number = (win.scrollY / bgHeight) * 100;
            $ani.css('animationDelay', '-' + (p > 100 ? 100 : p).toString() + 's');
            if (p >= 1 && $tutorialPopup && !tutorialShown) {
                $tutorialPopup.appendTo('body');
                localStorage.setItem(_.gcTutorialPopupKey, (++tutCounter).toString());
                tutorialShown = win.scrollY + window.innerHeight * 2;
            } else if ($tutorialPopup && typeof(tutorialShown) == 'number' && win.scrollY > tutorialShown) {
                $tutorialPopup.remove();
                $tutorialPopup = null;
            }
        }
    } else if (win.scrollY < top + height && hMode) {
        removeClass(hEl, 'clsScrolled');
        hMode = false;
        $(hEl).css('animationDelay', '-100s');
        $([tocEl, socEl]).css('animationDelay', '0s');
    }

    initial && scrollHandler();

    const p = win.scrollY * 100 / document.body.scrollHeight;
    const staShown = localStorage.getItem(_.gcSTAKey) == '1';
    const topTarget = isMobile ? (win.innerHeight * 3) * 100 / document.body.scrollHeight : 30;

    if (p > topTarget && p < 80 && !staPopup && !staShown) {
        staPopup = (pApp: any).showSTAPopup(true);
    } else if ((p > 85 || p < topTarget) && staPopup) {
        (pApp: any).showSTAPopup(false);
        staPopup = null;
    }
}
scrollHandler(true);

document.addEventListener('scroll', throttle(scrollHandler, 50));



// WEBPACK FOOTER //
// ./src/index.jsx